import React from 'react'

const Home = () => {
  return <div><h3>Home</h3></div>
}

export default Home
